import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-registration',
  templateUrl: './success-registration.component.html',
  styleUrls: ['./success-registration.component.css']
})
export class SuccessRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
